import client from "../../zafclient";

const buildViewerUrl = (src, name) => {
  const params = new URLSearchParams({
    view: "file_viewer",
    src,
    name: name || "File",
  });
  return `${window.location.origin}/?${params.toString()}`;
};

const openFileModal = (src, name) => {
  if (!src) return;
  if (!client || typeof client.invoke !== "function") {
    window.open(src, "_blank", "noopener,noreferrer");
    return;
  }
  client
    .invoke("instances.create", {
      location: "modal",
      url: buildViewerUrl(src, name),
      size: { width: "80vw", height: "80vh" },
    })
    .catch(() => {
      window.open(src, "_blank", "noopener,noreferrer");
    });
};

export default openFileModal;
